var N = /* @__PURE__ */ ((I) => (I.FINANCING_AUTOCREDIT = "auto-credit", I.FINANCING_CLASSICCREDIT = "classic-credit", I.FINANCING_INDIVIDUAL = "individual-credit", I.FINANCING_VARIO = "vario-credit", I.BUSINESS_LEASING = "bLeas", I.PRIVATE_LEASING = "pLeas", I.ABO = "abo", I))(N || {});
export {
  N as FdTypes
};
